import { locationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";

export const CrdbLocationSchema = z.object({
  id: locationIdFormat.schema,
  name: z.string(),
  externalId: z.string().nullish(),
});

export type CrdbLocation = z.infer<typeof CrdbLocationSchema>;

export const getCrdbLocations = {
  name: "getCrdbLocations" as const,
  input: zNull(),
  output: z.object({ locations: z.array(CrdbLocationSchema) }),
};
